
@switch (columnId) {
  @case ('merchantName') {
    <lib-text-table-column>
      {{ element.merchantName }}
    </lib-text-table-column>
  }
  @case (FundingResultsOrderBy.MID) {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case (FundingResultsOrderBy.CreatedUtc) {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case ('vituPayDepositAmount') {
    <lib-text-table-column>
      {{ element.vituPayDepositAmount | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case ('merchantDepositAmount') {
    <lib-text-table-column>
      {{ element.merchantDepositAmount | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case (FundingResultsOrderBy.FundingStatus) {
    <lib-funding-item-status-chip
      [status]="element.fundingStatus">
    </lib-funding-item-status-chip>
  }
  @case (FundingResultsOrderBy.FundedDateUtc) {
    <lib-date-time-label [dateUtc]="element.fundedDateUtc"></lib-date-time-label>
  }
  @default {
  }
}
